import React from "react";
import Pagination from "@material-ui/lab/Pagination";
import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
    paginationColor: {
        display: "flex",
        justifyContent: "center",
        "& .MuiPaginationItem-root": {
            color: theme.palette.ePrimary?.base + " !important",
        },
        "& .Mui-selected": {
            backgroundColor: theme.palette.ePrimary?.base + " !important",
            color: theme.palette.eWhite?.base + " !important",
        },
        "& .MuiPaginationItem-root": {
            height: "25px",
            minWidth: "25px"
        },
        padding: '0.3rem'
    },
}));

const E_PaginatationComponent = ({ totalPagesCount, page, handlePageChange }) => {
    let classes = useStyle();
    const handleOnPageChange = (event, pageNumber) => {
        handlePageChange(pageNumber)
    }
    return (
        <div>
            <Pagination
                count={totalPagesCount}
                page={page}
                onChange={handleOnPageChange}
                className={classes.paginationColor}
                siblingCount={0}
            />
        </div>
    )
}
export default E_PaginatationComponent;